// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "paper-1HZ3F";
var _4 = "title-1KDLF";
var _5 = "description-3MOQx";
var _6 = "footer-1xAiH";
var _7 = "button-19z8W";
var _8 = "scrollBody-3ZDNj";
export { _1 as "__esModule", _2 as "mobile", _3 as "paper", _4 as "title", _5 as "description", _6 as "footer", _7 as "button", _8 as "scrollBody" }
export default { "__esModule": _1, "mobile": _2, "paper": _3, "title": _4, "description": _5, "footer": _6, "button": _7, "scrollBody": _8 }
